import { render, staticRenderFns } from "./SemesterSwitchAlert.vue?vue&type=template&id=410b59bc&"
import script from "./SemesterSwitchAlert.vue?vue&type=script&lang=js&"
export * from "./SemesterSwitchAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports